<template>
  <form>
    <h4 class="card-title">{{$t('medium_grant.technical__5_detailed_desc_project')}}</h4>
    <h4 class="card-title">{{$t('medium_grant.technical__5_detailed_desc_project_sub')}}</h4>
    <div class="row">
      <div class="col-lg-12">
        <p>{{$t('medium_grant.technical__5_identify_the_country')}}</p>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.technical.detailedProjectLocation"
            >
            </textarea>
        </base-input>

        <div class="mt-5"></div>
        <p class="white-space-pre">{{$t('medium_grant.technical__5_describe_local_communities')}}</p>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.technical.describeLocalCommunities"
            >
            </textarea>
        </base-input>

        <div class="mt-5"></div>
        <h4 class="card-title">{{$t('medium_grant.technical__5_objective')}}</h4>
        <p class="mt-5">
          {{$t('medium_grant.technical__5_objective_sub')}}
        </p>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.technical.detailedObjective"
            >
            </textarea>
        </base-input>

        <div class="mt-5"></div>
        <h4 class="card-title">{{$t('medium_grant.technical__5_methodology')}}</h4>
        <p class="mt-5">
          {{$t('medium_grant.technical__5_methodology_sub')}}
        </p>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.technical.detailedMethodology"
            >
            </textarea>
        </base-input>

        <div class="mt-5"></div>
        <h4 class="card-title">{{$t('medium_grant.technical__5_intervention')}}</h4>
        <p class="mt-5">
          {{$t('medium_grant.technical__5_intervention_sub')}}
        </p>
        <p class="mt-2">
          {{$t('medium_grant.technical__5_intervention_sub2')}}
        </p>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.technical.interventionLogic"
            >
            </textarea>
        </base-input>

        <div class="mt-5"></div>
        <h4 class="card-title">{{$t('medium_grant.technical__5_stakeholders')}}</h4>
        <p class="mt-5">
          {{$t('medium_grant.technical__5_stakeholders_sub')}}
        </p>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.technical.detailedStakeHolders"
            >
            </textarea>
        </base-input>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>